// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__3i1YC"};